// @mui
import { GlobalStyles as MUIGlobalStyles } from '@mui/material';
//
import { STAGE } from './stage';

// ----------------------------------------------------------------------

const FROST_FALLBACK = { background: `${STAGE.frostSolid} !important` };

export default function GlobalStyles() {
  const inputGlobalStyles = (
    <MUIGlobalStyles
      styles={{
        '*': {
          boxSizing: 'border-box',
        },
        html: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
          WebkitTapHighlightColor: 'transparent',
          colorScheme: 'dark',
          background: STAGE.ground,
          scrollPaddingTop: '96px',
        },
        body: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          background: STAGE.ground,
          WebkitFontSmoothing: 'antialiased',
          textRendering: 'optimizeLegibility',
        },
        button: {
          font: 'inherit',
        },
        '::selection': {
          background: STAGE.selectionBg,
          color: STAGE.selectionInk,
        },
        ':focus-visible': {
          outline: `2px solid ${STAGE.focus}`,
          outlineOffset: '3px',
        },
        '[data-hero-fade]:focus-within': {
          opacity: '1 !important',
          transform: 'none !important',
        },
        '@supports not ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px)))': {
          '[data-frost]': FROST_FALLBACK,
        },
        '@media (prefers-reduced-transparency: reduce)': {
          '[data-frost]': {
            ...FROST_FALLBACK,
            backdropFilter: 'none !important',
            WebkitBackdropFilter: 'none !important',
          },
        },
        '@media (prefers-reduced-motion: reduce)': {
          '[data-enter]': {
            animation: 'none !important',
            transition: 'none !important',
            opacity: '1 !important',
            transform: 'none !important',
          },
        },
        '@media print': {
          html: { background: '#FFFFFF' },
          body: { background: '#FFFFFF', color: '#000000' },
        },
        '#root': {
          width: '100%',
          height: '100%',
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        img: {
          display: 'block',
          maxWidth: '100%',
        },
        ul: {
          margin: 0,
          padding: 0,
        },
      }}
    />
  );

  return inputGlobalStyles;
}
